export { CurrencySelectorModule } from './currency-selector.module';

export { CurrencySelectorComponent } from './currency-selector.component';
